import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = getCookie('tam_consent');
    if (!consent) {
      setVisible(true);
      // Default: opt out of PostHog until user accepts
      if (window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
        window.posthog.opt_out_capturing();
      }
    } else if (consent === 'essential') {
      if (window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
        window.posthog.opt_out_capturing();
      }
    } else if (consent === 'accepted') {
      if (window.posthog && typeof window.posthog.opt_in_capturing === 'function') {
        window.posthog.opt_in_capturing();
      }
    }
  }, []);

  const handleAcceptAll = () => {
    setCookie('tam_consent', 'accepted', 365);
    if (window.posthog && typeof window.posthog.opt_in_capturing === 'function') {
      window.posthog.opt_in_capturing();
    }
    setVisible(false);
  };

  const handleEssentialOnly = () => {
    setCookie('tam_consent', 'essential', 365);
    if (window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
      window.posthog.opt_out_capturing();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* Spacer to push page content above the banner */}
      <div className="h-28" />
      <div
        className="fixed bottom-4 left-4 right-4 z-[100] flex justify-center animate-fade-in"
        data-testid="cookie-consent-banner"
      >
        <div className="max-w-lg w-full bg-card border border-border rounded-2xl shadow-xl p-5">
          <p className="text-sm text-foreground mb-1 font-medium">{t('cookies.bannerTitle')}</p>
          <p className="text-xs text-muted-foreground mb-4">
            {t('cookies.bannerText')}{' '}
            <Link to="/cookies" className="underline hover:text-primary transition-colors">
              {t('cookies.learnMore')}
            </Link>
          </p>
          <div className="flex gap-3">
            <Button
              size="sm"
              className="btn-organic bg-primary text-primary-foreground flex-1"
              onClick={handleAcceptAll}
              data-testid="cookie-accept-all-btn"
            >
              {t('cookies.acceptAll')}
            </Button>
            <Button
              size="sm"
              variant="outline"
              className="btn-organic flex-1"
              onClick={handleEssentialOnly}
              data-testid="cookie-essential-only-btn"
            >
              {t('cookies.essentialOnly')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
